<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">Transactions</h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <div class="row">
            <div class="col-md-12 add_ded_tbl">
              <a class="com_btn" (click)="vip_sub_transactions('1')"
                >Transactions</a
              >
              <a class="com_btn" (click)="vip_sub_transactions('2')"
                >Deductions</a
              >
              <a class="com_btn" (click)="slot_transactions()"
                >Slot Transactions</a
              >
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 add_ded_tbl">
              <table class="table" *ngIf="tab_type == 1 || tab_type == 2">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <th scope="col">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col">Customer ID</th>
                    <th scope="col" *ngIf="tab_type == 1">Amount ($)</th>
                    <th scope="col" *ngIf="tab_type == 1">30% ($)</th>
                    <th scope="col" *ngIf="tab_type == 1">15% ($)</th>
                    <th scope="col">Date</th>
                    <th scope="col">Select User</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of transactions; let a = index">
                    <th scope="row">{{ transactions.length - a }}</th>
                    <td>
                      <span *ngIf="i.typeis == 1">Tokens</span>
                      <span *ngIf="i.typeis == 2">Subscription</span>
                      <span *ngIf="i.typeis == 3">Subscription Update</span>
                      <span *ngIf="i.add_deduct == 'deduct'">
                        <span *ngIf="i.type == 0"
                          ><i class="fas fa-coins"></i
                        ></span>
                        <span *ngIf="i.type == 1"
                          ><i class="fab fa-google"></i
                        ></span>
                        <span *ngIf="i.type == 2"
                          ><i class="fab fa-instagram"></i
                        ></span>
                        <span *ngIf="i.type == 3"
                          ><i class="fab fa-twitter"></i
                        ></span>
                        <span *ngIf="i.type == 4"> GM {{ i.show }} </span>
                        <span *ngIf="i.type == 5"> ST {{ i.show }} </span>
                        <span *ngIf="i.type == 6 || i.type == 7">
                          {{ i.show }}
                        </span>
                      </span>
                    </td>
                    <td>
                      <span *ngIf="i.typeis == 2">
                        <span *ngIf="i.price == '99' || i.price == '149'"
                          >Biz</span
                        >
                        <span *ngIf="i.price == '159' || i.price == '219'"
                          >Enterprise</span
                        >
                        <span *ngIf="i.price == '199' || i.price == '259'"
                          >Ultimate</span
                        >
                      </span>
                      <span *ngIf="i.typeis == 1">
                        <span *ngIf="i.add_deduct == 'add'"
                          >Add VIP Token {{ i.tokens }}</span
                        >
                        <span *ngIf="i.add_deduct == 'deduct'"
                          >Deduct VIP Token {{ i.tokens }}</span
                        >
                      </span>
                      <span *ngIf="i.add_deduct == 'deduct'">
                        Deducted Tokens : {{ i.tokens }}
                      </span>
                    </td>
                    <td>{{ i.email }}</td>
                    <td *ngIf="tab_type == 1">{{ i.price }}</td>
                    <td *ngIf="tab_type == 1">
                      {{ (0.3 * i.price).toFixed(2) }}
                    </td>
                    <td *ngIf="tab_type == 1">
                      {{ (0.15 * i.price).toFixed(2) }}
                    </td>
                    <td>{{ i.created * 1000 | date : "mediumDate" }}</td>
                    <td>
                      <select
                        class="form-control"
                        (change)="onChangeUser($event, i.id)"
                        [(ngModel)]="i.selectedUser"
                      >
                        <option disabled selected>Select</option>
                        <option
                          *ngFor="let user of userDropdown"
                          value="{{ user.name }}"
                        >
                          {{ user.name }}
                        </option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table" *ngIf="tab_type == 3">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <th scope="col">Client Name</th>
                    <th scope="col">Amount ($)</th>
                    <th scope="col">Slots</th>
                    <th scope="col">Txn. Status</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of slotTransactions; let a = index">
                    <th scope="row">{{ slotTransactions.length - a }}</th>
                    <td>{{ i?.user?.userName }}</td>
                    <td>{{ i.amount }}</td>
                    <td>{{ i.slots }}</td>
                    <td>{{ i.status }}</td>
                    <td>{{ i.created * 1000 | date : "mediumDate" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
